import { allFieldsValidationCommon, customErrorMessagesCommon } from "../Validation";
import { QUOTE_QUESTIONS } from "../../AppConstants";

const rules = {
    ownership: 'required',
    payments: 'required_if:ownership,' + QUOTE_QUESTIONS.VEHICLE_DETAILS.OWNERSHIP.OWN,
    //useYears: 'required',
};

export const allFieldsValidation = (data) => {
    return allFieldsValidationCommon(data, rules, customErrorMessagesCommon);
};